import React from 'react'
import { useState,useEffect } from 'react'
import { getPuestosByLocalId } from '../../../../../../crud/management_api/puestos'
import { getSalonesByLocalId } from '../../../../../../crud/management_api/salones'
import {Puesto,PuestoUser,WaiterStats,Salon,Mesa,ReceiptResumen} from '../types'
import { getPaymentReceiptsFromCurrentSessionByLocalId } from '../../../../../../crud/payments_api/payment_receipts'
import {SalesStatistics} from '../../Panel'
import './WaitersStats.scss'
import { FaUser, FaPlus, FaMinus, FaEye, FaArrowUp, FaArrowDown } from 'react-icons/fa'


type Props = {
    data: SalesStatistics;
}



const WaitersStats = (props: Props) => {
    const [waiters, setWaiters] = useState<PuestoUser[]>([]);
    const [puestos , setPuestos] = useState<Puesto[]>([]);
    const [waiterStats, setWaiterStats] = useState<WaiterStats[]>([]); // Renombrado a minúscula
    const [salones, setSalones] = useState<Salon[]>([]); // Ajustar tipo si es necesario
    const [receiptsResumen, setReceiptsResumen] = useState<ReceiptResumen[]>([]);
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const [showAll, setShowAll] = useState(false);


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 900);
        }
        handleResize(); // Inicializar el estado
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }
    , []);

    //llamadas api
    //obtener los garzones

    useEffect(() => {
        const userContext = localStorage.getItem('user');
        const localId = userContext ? JSON.parse(userContext).local_id : 0;
        getPuestosByLocalId(localId)
            .then((response) => {
                const waitersList = response.data.filter((puesto: Puesto) => puesto.is_waiter);
                setWaiters(waitersList.flatMap((puesto: Puesto) => puesto.users));
                setPuestos(waitersList);
            })
            .catch(console.error);
    }, []);

    //obtener los salones

    useEffect(() => {
        const userContext = localStorage.getItem('user');
        const localId = userContext ? JSON.parse(userContext).local_id : 0;
        getSalonesByLocalId(localId)
            .then((response) => {
                setSalones(response.data);
            })
            .catch(console.error);
    }
    , []);

    //obtener los recibos de la sesion actual
    useEffect(() => {
        const userContext = localStorage.getItem('user');
        const localId = userContext ? JSON.parse(userContext).local_id : 0;
        getPaymentReceiptsFromCurrentSessionByLocalId(localId)
            .then((response) => {
                setReceiptsResumen(response.data);
            })
            .catch(console.error);
    }, []);

    useEffect(() => {
        // Solo calcular si hay waiters, salones, recibos y data de stats
        if (waiters.length === 0 || salones.length === 0 || receiptsResumen.length === 0 || !props.data) return;
        // Creamos un array de WaiterStats
        const stats: WaiterStats[] = waiters.map((waiter) => {
            let current_clients = 0;
            let pending_cash = 0;
            let cancellations = 0;
            let cancellations_amount = 0;
            let total_sales = 0;
            let avg_tip_variation = 0;
            salones.forEach((salon: Salon) => {
                salon.mesas.forEach((mesa: Mesa) => {
                    if (mesa.user_id === waiter.user_id) {
                        current_clients += mesa.people;
                    }
                });
            });

            // Sumar ventas pendientes de pago del dia actual
            receiptsResumen.forEach((receipt: ReceiptResumen) => {
                if (
                    receipt.user_id === waiter.user_id &&
                    receipt.total_due > 0 &&
                    receipt.active === true
                ) {
                    pending_cash += receipt.total_due;
                }
            });

            // Sumar ventas totales del mesero

            // Sumar cancelaciones desde data.user_stats
            const userStats = props.data.users_stats?.[waiter.user_id?.toString() || ''];
            if (userStats && typeof userStats.cancelled === 'number') {
                cancellations = userStats.cancelled;
                cancellations_amount = userStats.cancelled_amount || 0;
            }

            if (userStats) {
                total_sales = userStats.total;
            }

            if (userStats && typeof userStats.avg_tip_variation === 'number') {
                avg_tip_variation = userStats.avg_tip_variation;
            }

            return {
                user_id: waiter.user_id,
                username: waiter.username,
                name: waiter.username + (waiter.user_lastname ? ' ' + waiter.user_lastname : ''),
                current_clients,
                pending_cash, // ahora es number, no string
                cancellations,
                cancellations_amount,
                total_sales,
                avg_tip_variation
            };
        });
        setWaiterStats(stats);
    }, [waiters, salones, receiptsResumen, props.data]);

    // Filter waiters with meaningful data and sort them
    const filteredAndSortedWaiterStats = [...waiterStats]
        .filter(waiter => 
            // Only show waiters with pending cash > 0 OR total sales > 0
            (waiter.pending_cash && waiter.pending_cash > 0) || 
            (waiter.total_sales && waiter.total_sales > 0)
        )
        .sort((a, b) => {
            // Sort by pending cash first, then by total sales
            const pendingDiff = (b.pending_cash || 0) - (a.pending_cash || 0);
            if (pendingDiff !== 0) return pendingDiff;
            return (b.total_sales || 0) - (a.total_sales || 0);
        });

    // Render variation indicator component
    const renderVariationIndicator = (variation: number | undefined) => {
        if (!variation || variation === 0) return null;
        
        const isPositive = variation > 0;
        return (
            <div className={`variation-indicator ${isPositive ? 'positive' : 'negative'}`}>
                {isPositive ? <FaArrowUp /> : <FaArrowDown />}
                <span>{Math.abs(variation).toFixed(2)}%</span>
            </div>
        );
    };

  return (
    <div className='card-container-waiters-stats'>
        <div className='card-header'>
            <FaUser className='waiters-stats-icon' />
            <h3>Meseros</h3>
        </div>
        <div className='card-body'>
            <table className="waiters-stats-table">
                <thead>
                    <tr>
                        <th><span>Nombre</span></th>
                        <th className='no-responsive'><span>N° clientes</span></th>
                        <th className='no-responsive'>
                            <span>{isMobile ? 'Pendiente' : '$ Pendiente'}</span>
                        </th>
                        <th>
                            <span>{isMobile ? 'Total ventas' : '$ Total ventas'}</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {(showAll ? filteredAndSortedWaiterStats : filteredAndSortedWaiterStats.slice(0, 2)).filter(
                        waiter => (
                          (waiter.name && waiter.name !== 'undefined' && waiter.name.trim() !== '') ||
                          (waiter.username && waiter.username !== 'undefined' && waiter.username.trim() !== '')
                        )
                      ).map((waiter, idx) => (
                        <tr key={waiter.user_id || idx}>
                            <td>{
                              waiter.name && waiter.name !== 'undefined' && waiter.name.trim() !== ''
                                ? waiter.name
                                : (waiter.username && waiter.username !== 'undefined' && waiter.username.trim() !== '' ? waiter.username : '-')
                            }</td>
                            <td className='no-responsive'>{waiter.current_clients ?? '-'}</td>
                            <td className='no-responsive'>
                                <div className="amount-with-variation">
                                    {waiter.pending_cash !== undefined ? (
                                        <>
                                            <span className="amount">
                                                {`$${waiter.pending_cash.toLocaleString('es-CL', {minimumFractionDigits: 0, maximumFractionDigits: 0})}`}
                                            </span>
                                            {waiter.pending_cash > 0 && (
                                                <FaEye
                                                    className="view-icon"
                                                    onClick={() => window.location.href = `/App/Receipts?pendingUserId=${waiter.user_id}`}
                                                    title="Ver caja"
                                                />
                                            )}
                                        </>
                                    ) : '-'}
                                </div>
                            </td>
                            <td>
                                <div className="amount-with-variation">
                                    <span className="amount">
                                        {waiter.total_sales ? `$${waiter.total_sales.toLocaleString('es-CL', {minimumFractionDigits: 0, maximumFractionDigits: 0})}` : '-'}
                                    </span>
                                    {renderVariationIndicator(waiter.avg_tip_variation)}
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className='waiters-stats-footer'>
                {filteredAndSortedWaiterStats.length > 2 && (
                    <button onClick={() => setShowAll(v => !v)} className="waiters-stats-toggle-btn">
                        {showAll ? (<><FaMinus/> Ver menos</>) : (<><FaPlus/> Ver más</>)}
                    </button>
                )}
            </div>
        </div>
    </div>
  )
}

export default WaitersStats